import { IAppUserDto } from "../Models/IAppUserDto";
import { baseUrl } from "./constants";
import { fetchWrapper } from "./fetchwrapper";

export const getAllAcademyUsers = () => {
  return fetchWrapper
    .getWithAuth(`${baseUrl}/api/academy/GetAcademyUsers`)
    .then((data: IAppUserDto[]) => {
      return data;
    });
};

export const getLuebberingUsers = () => {
  return fetchWrapper
    .postWithAuth(`${baseUrl}/api/account/getbyquery`, {
      rollen: [],
      firma: "",
      vorname: "",
      nachname: "",
      eMail: "luebbering",
      kundennummer: "",
      stadt: "",
      sprache: "",
      onlyDemo: false,
      isDeleted: 0,
      IsVerified: 2,
      deleteRequested: 2,
      hasFaultyRoleAssignment: false,
      configuratorButNoTools: 0,
      preiseSichtbar: 2,
    })
    .then((data: IAppUserDto[]) => {
      return data;
    });
};
